import React from "react";
import PropTypes from "prop-types";
import UnifiedSearchAutocompleteComponent from "../unified_search_autocomplete_component";
const hardCodedOptions = [
  { name: "REPORT FOR GUEST", id: null },
  { name: "UNKNOWN CLIENT (UNLINKED)", id: null }
];

function ClientSearchInputAutocomplete({ selected_client_name = "", options }) {
  const redirectWithQuery = (clientName = null) => {
    const searchParams = new URLSearchParams(window.location.search);

    if (clientName) {
      searchParams.set("client_name", clientName);
    } else {
      searchParams.delete("client_name");
    }

    const queryString = searchParams.toString();
    window.location.href = queryString ? `/incident_reports?${queryString}` : "/incident_reports";
  };

  const handleFormSubmit = (option) => {
    if (option) {
      redirectWithQuery(option.name);
    }
  };

  const handleDropdownClick = (option) => {
    redirectWithQuery(option.name);
  };
  const handleClearClick = () => {
    redirectWithQuery();
  };

  return (
    <UnifiedSearchAutocompleteComponent
      selected_name={selected_client_name}
      options={options}
      hardCodedOptions={hardCodedOptions}
      handleFormSubmit={handleFormSubmit}
      handleDropdownItemClick={handleDropdownClick}
      inputFieldId="selected_client_name"
      inputFieldPlaceholder="Search by Client name"
      handleClearClick={handleClearClick}
      handleOnSelectedOptionChange={() => {}}
    />
  );
}

ClientSearchInputAutocomplete.propTypes = {
  selected_client_name: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string.isRequired
    })
  ).isRequired
};

export default ClientSearchInputAutocomplete;
